import { useEffect, useState } from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  ariaLabel?: string;
}

const KAKAO_CHANNEL_ID = '_SNpdX';

export default function KakaoTalkButton({ children, className = '', style, ariaLabel }: Props) {
  const [kakaoUrl, setKakaoUrl] = useState<string>(`https://pf.kakao.com/${KAKAO_CHANNEL_ID}`);

  useEffect(() => {
    // 모바일 기기 감지
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

    if (isMobile) {
      // 모바일에서는 바로 1:1 채팅 열기
      setKakaoUrl(`http://pf.kakao.com/${KAKAO_CHANNEL_ID}/chat`);
    } else {
      // PC에서는 채널 메인 페이지로 (채널 페이지에서 채팅 버튼 클릭 가능)
      setKakaoUrl(`https://pf.kakao.com/${KAKAO_CHANNEL_ID}`);
    }
  }, []);

  return (
    <a
      href={kakaoUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
      aria-label={ariaLabel}
    >
      {children}
    </a>
  );
}